import { render, staticRenderFns } from "./wzvz_overview_all.vue?vue&type=template&id=e615d010&scoped=true"
import script from "./wzvz_overview_all.vue?vue&type=script&lang=js"
export * from "./wzvz_overview_all.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e615d010",
  null
  
)

export default component.exports